<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="800" v-if="dialog">
            <v-card>
                <v-card-title class="headline">시설물 점검 시스템 관리자 페이지는 IE를 지원하지 않습니다</v-card-title>
                <v-card-text>보다 안정적인 서비스 이용을 위해 Chrome 브라우져 이용을 권장드립니다<br>
                크롬브라우져 다운로드 페이지로 이동할까요?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           @click="selectMoveToDownload()"
                    >브라우져 다운로드 바로가기
                    </v-btn>

                    <v-btn color="error"
                           @click="selectDismiss()"
                    >닫기
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        props: {
            dialog: Boolean,
        },
        methods: {
            selectDismiss(){
                this.dialog = false
            },
            selectMoveToDownload(){
                this.dialog = false
                window.location.href = "https://www.google.com/intl/ko/chrome/"

            }
        }
    }
</script>
